import { create } from 'zustand';

/** Syncs canvas chrome (e.g. #canvas data-attributes) from Flow to the shell that owns `#canvas`. */
interface CanvasChromeState {
  hasSelectedNodes: boolean;
  setHasSelectedNodes: (value: boolean) => void;
}

export const useCanvasChromeStore = create<CanvasChromeState>((set) => ({
  hasSelectedNodes: false,
  setHasSelectedNodes: (value) => set({ hasSelectedNodes: value }),
}));
